import React                                     from 'react';
import { Observe }                                    from 'rewire-core';
import {
  Theme,
  CSSTheme,
}                                                     from 'rewire-ui';
import Button                                         from '@material-ui/core/Button';
import Icon                                           from '@material-ui/core/Icon';
import List                                           from '@material-ui/core/List';
import ListItem                                       from '@material-ui/core/ListItem';
import ListItemText                                   from '@material-ui/core/ListItemText';
import Typography                                     from '@material-ui/core/Typography';
import { makeStyles }                                 from '@material-ui/styles';
import Grid                                           from '../ui/Grid';
import Loader                                         from '../ui/Loader';
import AddValidationRuleDialog                        from './AddValidationRuleDialog';
import ValidationRuleEditorInfoPanel                  from './ValidationRuleEditorInfoPanel';
import ValidationRuleEditorModel                      from './ValidationRuleEditorModel';

const validationRuleEditorStyle = (theme: Theme) => ({
  root: {
    display: 'flex',
    flex: '1',
    minHeight: 200,
  },
  rootLeft: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
  },
  contentRoot: {
    display: 'flex',
    flex: '1',
    '& td.result': {
      borderLeft: `2px solid ${theme.palette.error.dark}`
    }
  },
  menuItem: {
    minWidth:   '300px',
  },
  menuButton: {
    minWidth:   '0px',
    minHeight:  '0px',
    padding:    '0px',
    margin: 0
    // marginLeft: '8px',
  },
  left: {
    flex: '0 0 250px',
    margin: '0 8px 0 0',
    border: `1px solid ${theme.palette.grey['300']}`
  },
  title: {
    display: 'flex',
    alignSelf: 'stretch',
    alignItems: 'center',
    '& button': {marginLeft: 8},
    '& h6': {flex: 1}
  },
  header: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    flexDirection: 'column',
    margin: '0px 0px 8px 0px',
  },
  right: {
    display: 'flex',
    flex: '1',
    // minWidth: '450px',
  },
  button: {
    textTransform: 'none',
  },
} as CSSTheme);

const useValidationRuleEditorStyle = makeStyles(validationRuleEditorStyle);

const ValidationsRuleEditor = React.memo(({settings}: {settings: ValidationRuleEditorModel}) => {
  const classes = useValidationRuleEditorStyle();
  return (
    <>
    <Observe render={() => (
      <div className={classes.root}>
        <div className={classes.rootLeft}>
          <div className={classes.header}>
            <div className={classes.title}>
              <Typography variant='h6'>{settings.titleText}</Typography>
              <Observe>{() => (
                <Button className={classes.button} variant='contained' disabled={settings.viewOnly} onClick={() => settings.showAddRuleDialog()}>
                  <Icon className='add'>{'add'}</Icon>
                  <span>{'Add Validation Rule'}</span>
                </Button>
              )}</Observe>
            </div>
          </div>
          <div className={classes.contentRoot} >
            <div className={classes.left}>
              <List component='nav'>
                {settings.tables.map(table => <ListItem selected={table.selected} key={table.id} button onClick={() => settings.selectItem(table)}><ListItemText primary={table.name} /></ListItem>)}
              </List>
            </div>
            <div className={classes.right}>
              <Observe>{() => (
                <Loader loading={settings.isLoading}>
                  <Observe>{() => (
                    <Grid grid={settings.grid} style={{height: '100%'}} />
                  )}</Observe>
                </Loader>
              )}</Observe>
            </div>
          </div>
        </div>
        <Observe>{() => (
          <ValidationRuleEditorInfoPanel model={settings.validationRuleEditorInfoPanelModel} />
        )}</Observe>
      </div>
    )} />
    <AddValidationRuleDialog model={settings.addValidationRuleDialogModel} />
    </>
  );
});

export default ValidationsRuleEditor;
